"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactMdSpinner = require("react-md-spinner");

var _reactMdSpinner2 = _interopRequireDefault(_reactMdSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Spinner, _Component);

  function Spinner() {
    (0, _classCallCheck3.default)(this, Spinner);
    return (0, _possibleConstructorReturn3.default)(this, (Spinner.__proto__ || (0, _getPrototypeOf2.default)(Spinner)).apply(this, arguments));
  }

  (0, _createClass3.default)(Spinner, [{
    key: "render",
    value: function render() {
      var defaultOptions = {
        size: 32,
        color1: "#49953d",
        color2: "#fb761d",
        color3: "#49953d",
        color4: "#fb761d"
      };
      var classNames = "mp-spinner";

      if (this.props.additionalClasses) {
        classNames += " " + this.props.additionalClasses;
      }

      var props = (0, _assign2.default)({}, defaultOptions, this.props.options);
      return _react2.default.createElement(
        "div",
        { className: classNames },
        _react2.default.createElement(_reactMdSpinner2.default, props)
      );
    }
  }]);
  return Spinner;
}(_react.Component), _class.propTypes = {
  options: _react.PropTypes.object,
  additionalClasses: _react.PropTypes.string
}, _temp);
exports.default = Spinner;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Spinner.js
 ** module id = 132
 ** module chunks = 0
 **/